<template>
   <div :class="['guide-to-phone', isFullScreen && 'guide-to-phone-fullscreen']">
    <div class="guide-title">微信扫码 用手机继续看</div>
    <qrcode
      class="guide-qrcode"
      :value="url"
      :size="isFullScreen ? 180 : 120"
    ></qrcode>
    <img v-if="showFigure" class="guide-img" src="~/assets/image/guide-user-to-mobile.svg"/>
    <icon
      v-if="close"
      type="iconic_cancel_pop"
      class="guide-close"
      @click="close"
    ></icon>
   </div>
</template>

<script>
import Qrcode from '@/components/qrcode';

export default {
  data() {
    return {
    };
  },

  props: {
    url: String,
    close: Function,
    showFigure: Boolean,
    isFullScreen: Boolean
  },

  components: {
    Qrcode,
  },
};
</script>

<style lang="scss" scoped>
.guide-to-phone {
  width: 300px;
  height: 230px;
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid rgba(17, 19, 23, 0.2);
  box-shadow: 0 12px 24px 0 rgba(17, 19, 23, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  .guide-title {
    margin-top: 30px;
    font-size: 18px;
    font-weight: bold;
    color: #111317;
    line-height: 28px;
  }
  .guide-qrcode {
    margin-top: 20px;
  }
  .guide-img {
    position: absolute;
    width: 170px;
    height: 155px;
    bottom: 0px;
    left: -77px;
  }
  .guide-close {
    @include close-btn-style();
    position: absolute;
    right: 14px;
    top: 14px;
  }
  &-fullscreen {
    width: 450px;
    height: 345px;
    border-radius: 18px;
    .guide-title {
      margin-top: 46px;
      font-size: 26px;
      line-height: 42px;
    }
    .guide-qrcode {
      margin-top: 29px;
      width: 180px;
      height: 180px;
      ::v-deep .qrcode-logo {
        width: 30px;
        height: 30px;
      }
    }
    .guide-img {
      width: 256px;
      height: 234px;
      left: -128px;
    }
    .guide-close {
      right: 20px;
      top: 20px;
      font-size: 20px;
    }
  }
}
</style>